export default __webpack_public_path__ + "static/media/POINTER.027e9224.svg";